import { useEffect } from "react";
import { Button, IconButton, TextField, makeStyles } from "@material-ui/core";
import { useDynamicList, useUpdateEffect } from "ahooks";
import clsx from "clsx";
import { IconTrash } from "@/components/Icon";
import { useTranslation } from "@/langs/useTranslation";

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: 4,
    overflow: "hidden",
    border: "1px solid #E9E8ED",
    marginTop: theme.spacing(2)
  },
  header: {
    backgroundColor: "#F8F9FC"
  },
  item: {
    display: "flex",
    alignItems: "center",

    "&:not(:last-child)": {
      borderBottom: "1px solid #E9E8ED"
    },
    "& > div": {
      padding: theme.spacing(1)
    },
    "& > div:nth-child(1)": {
      flex: 1
    },
    "& > div:nth-child(2)": {
      flex: 1
    },
    "& > div:nth-child(3)": {
      flex: 1.5
    }
  }
}));

const Header = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={clsx(classes.item, classes.header)}>
      <div>{t({ defaultMessage: "姓名" })}</div>
      <div>{t({ defaultMessage: "邮箱" })}</div>
      <div>{t({ defaultMessage: "手机号" })}</div>
    </div>
  );
};

const Item = ({ index, disabled, item, remove, replace }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.item}>
      <div>
        <TextField
          variant="outlined"
          size="small"
          style={{ width: 210 }}
          placeholder={t({ defaultMessage: "请填写姓名" })}
          disabled={disabled}
          value={item.name}
          onChange={e => replace(index, { ...item, name: e.target.value })}
        />
      </div>
      <div>
        <TextField
          variant="outlined"
          size="small"
          style={{ width: 210 }}
          placeholder={t({ defaultMessage: "请填写邮箱" })}
          disabled={disabled}
          value={item.email}
          onChange={e => replace(index, { ...item, email: e.target.value })}
        />
      </div>
      <div>
        <TextField
          variant="outlined"
          size="small"
          style={{ width: 210 }}
          placeholder={t({ defaultMessage: "请填写手机号" })}
          disabled={disabled}
          value={item.phone}
          onChange={e => replace(index, { ...item, phone: e.target.value })}
        />

        {!disabled && (
          <IconButton style={{ float: "right" }} onClick={() => remove(index)}>
            <IconTrash color="secondary" size={14} />
          </IconButton>
        )}
      </div>
    </div>
  );
};

const AlarmNotifyExtraUsers = ({ disabled, name, value = [], onChange }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { list, getKey, insert, remove, replace } = useDynamicList(value);

  const handleInsert = () => {
    insert(list.length, { name: "", email: "", phone: "", extra: true });
  };

  useUpdateEffect(() => {
    onChange?.({ target: { name, value: list } });
  }, [list]);

  return (
    <>
      <Button
        color="primary"
        variant="contained"
        disabled={disabled}
        onClick={handleInsert}
      >
        {t({ defaultMessage: "添加例外对象" })}
      </Button>
      <div className={classes.root}>
        <Header />
        {list.map((item, index) => (
          <Item
            key={getKey(index)}
            disabled={disabled}
            index={index}
            item={item}
            remove={remove}
            replace={replace}
          />
        ))}
      </div>
    </>
  );
};

export default AlarmNotifyExtraUsers;
